import { render } from "./ComponenteInputMatrizAnual.vue?vue&type=template&id=124847fa&scoped=true"
import script from "./ComponenteInputMatrizAnual.vue?vue&type=script&lang=js"
export * from "./ComponenteInputMatrizAnual.vue?vue&type=script&lang=js"

import "./ComponenteInputMatrizAnual.vue?vue&type=style&index=0&id=124847fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124847fa"]])

export default __exports__